import { useContext, useEffect, useRef, useState } from "react";
import "./Search.css";
import SearchDrop from "./SearchDrop/SearchDrop";
import { CloseSearch, SearchIcon } from "../../assets/icons/icons";
import { motion } from 'framer-motion';
import mainApi from "../../assets/api/MainApi";
import useWindowSize from "../../assets/hooks/useWindowSize";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ConfigContext } from "../../assets/contexts/configContext";

function Search({ className, placeholder, type = 'search', selectSearchItem, onlyInput, customValue, setCustomValue, setCustomPreloader }) {
    const [searchOpen, setSearchOpen] = useState(false)
    const config = useContext(ConfigContext)
    const { initialConstants } = config
    const { SHOP_ID_FOR_API, SHOP_NAME } = initialConstants
    const navigate = useNavigate()

    const searchRef = useRef()
    const [searchValue, setSearchValue] = useState(null)
    const [isSearchPreloaderVisible, setSearchPreloaderVisible] = useState(false)
    const [isSearchCatPreloaderVisible, setSearchCatPreloaderVisible] = useState(false)
    const [isDropDownOpened, setDropDownOpened] = useState(false)
    const [searchItems, setSearchItems] = useState(undefined)
    const [searchCategories, setSearchCategories] = useState(undefined)
    const { width } = useWindowSize();
    const location = useLocation()

    useEffect(() => {
        if (onlyInput) return
        const delayDebounceFn = setTimeout(() => {
            console.log(searchValue)
            if (!searchValue) return
            mainApi.getSearch({
                shop_id: SHOP_ID_FOR_API,
                string: searchValue,
                limit: 25,
                content_types: ["published"],
            })
                .then((res) => {
                    console.log(res.data)
                    setSearchItems(res.data)
                    // setSearchItems(RESULT_SEARCH)
                })
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    setSearchPreloaderVisible(false)
                })
            mainApi.getSearch({
                shop_id: SHOP_ID_FOR_API,
                string: searchValue,
                limit: 25,
                content_types: ["categories"]
            })
                .then((res) => {
                    console.log(res.data)
                    setSearchCategories(res.data)
                    // setSearchItems(RESULT_SEARCH)
                })
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    setSearchCatPreloaderVisible(false)
                })

        }, 500)

        return () => clearTimeout(delayDebounceFn)
    }, [searchValue])


    function hendleSearchChange(e) {
        let inputValue = e.target.value
        if (onlyInput) {
            setCustomValue(inputValue)
            if (inputValue === '') {
                setCustomPreloader(false)
            }
            else {
                setCustomPreloader(true)
            }
        } else {

            setSearchValue(inputValue)
            if (e.target.value === '') {
                setDropDownOpened(false)
            }
            else {
                setDropDownOpened(true)
                setSearchPreloaderVisible(true)
            }
        }

    }

    function hendleKeyDown(e) {
        // console.log(e.keyCode)
        if (e.keyCode === 13 && searchValue) {
            navigate(`/search?value=${searchValue}`)
            Clear()
        }
        if (e.keyCode === 27) {
            Clear()
        }
    }

    function handleDropDownOpen() {
        if (searchValue !== '' && searchValue !== null) setDropDownOpened(true)
    }

    function Clear() {
        setSearchValue('')
        console.log(searchValue)
        setSearchOpen(prevState => !prevState)
        // if (searchValue === '' && searchValue === null && width > 780) {
        //     setSearchOpen(!searchOpen)
        // }
    }
    const textInput = useRef(null);

    useEffect(() => {
        if (searchOpen) {
            textInput.current?.focus();
        }
    }, [searchOpen]);

    useEffect(() => {
        setDropDownOpened(false)
    }, [location])


    useEffect(() => {
        // Only attach the listener if search is currently open
        if (!searchOpen) return;

        const handleClickOutside = (e) => {
            // If the click is outside the searchRef area, close the search
            if (searchRef.current && !searchRef.current.contains(e.target)) {
                setDropDownOpened(false)
                setSearchOpen(false)
                setSearchValue('')
            }
        };

        // Attach the event listener
        document.addEventListener('mousedown', handleClickOutside);

        // Clean up the event listener when the component unmounts or searchOpen changes
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [searchOpen, setSearchOpen, searchRef]);

    return (
        <div
            ref={searchRef}
            className={`search__input-container ${className ? className : ''}`}>
            <div className='search__search-box'>
                <div className='search__input-box' onClick={handleDropDownOpen}>
                    <input onKeyDown={hendleKeyDown} ref={textInput} placeholder={placeholder ? placeholder : "Looking for your perfect timepiece"} className="search__input" name="search" type="text" value={onlyInput ? customValue : searchValue} onChange={hendleSearchChange} maxLength="50"></input>

                </div>
                {(customValue || searchValue) && type === 'search' ?
                    (
                        <Link
                            to={`/search?value=${customValue ? customValue : searchValue}`}
                            onClick={() => {
                                setSearchOpen(false);
                                setSearchValue('');
                            }}
                        >
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16 15.9998L13.1067 13.1064" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M13.1046 5.56209C15.1874 7.64489 15.1874 11.0218 13.1046 13.1046C11.0218 15.1874 7.64489 15.1874 5.56209 13.1046C3.4793 11.0218 3.4793 7.64489 5.56209 5.56209C7.64489 3.4793 11.0218 3.4793 13.1046 5.56209Z" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </Link>
                    )
                    :
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16 15.9998L13.1067 13.1064" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M13.1046 5.56209C15.1874 7.64489 15.1874 11.0218 13.1046 13.1046C11.0218 15.1874 7.64489 15.1874 5.56209 13.1046C3.4793 11.0218 3.4793 7.64489 5.56209 5.56209C7.64489 3.4793 11.0218 3.4793 13.1046 5.56209Z" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                }


            </div>
            {!onlyInput ?
                <SearchDrop selectSearchItem={selectSearchItem} type={type} searchRef={searchRef} Clear={Clear} isSearchPreloaderVisible={isSearchPreloaderVisible || isSearchCatPreloaderVisible} isOpened={isDropDownOpened} setOpened={setDropDownOpened} searchItems={searchItems} searchCategories={searchCategories} />
                : null}

        </div>

    );
}

export default Search;